import styled from "@emotion/styled";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { getStyles } from "src/styles/theme";
import defaultStyles from "./styles";

export type DashBoardTable = {
  topHeader: string[];
  header: string[];
  data: any;
};

export function EntityDashBoardTable({
  data,
  header,
  topHeader,
}: DashBoardTable) {
  const styles = getStyles(defaultStyles);

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 600 }} aria-label="simple table">
        <TableHead {...styles("header")}>
          <TableRow>
            {topHeader.map((item, index) => (
              <TableCell
                align="center"
                {...styles("cell")}
                key={index}
                colSpan={2}
              >
                {item}
              </TableCell>
            ))}
          </TableRow>
          <TableRow>
            {header.map((item, index) => (
              <TableCell align="center" {...styles("cell")} key={index}>
                {item}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => {
            return (
              <TableRow>
                <TableCell align="center" {...styles("cell")}>
                  {row.sno}
                </TableCell>
                <TableCell
                  align="center"
                  {...styles("cell", { width: "180px" })}
                >
                  {row.state}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalNumber}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalArea}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalNumberDemandNotePending}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalAreaDemandNotePending}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalNumberPaymentPending}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalAreaPaymentPending}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalNumberApproved}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalAreaApproved}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalNumberDeselect}
                </TableCell>
                <TableCell align="center" {...styles("cell")}>
                  {row.totalAreaDeselect}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
